<template lang="pug">
eventengine
  div(v-if="wcMode")
    #new-ui.modal.modal-common.fade(tabindex='-1' role='dialog' aria-labelledby='new-ui' aria-hidden='true')
      .modal-dialog.modal-dialog-centered(role='document')
        .modal-content
          .btn-close(data-bs-dismiss='modal' aria-label='Close')
            i.fas.fa-times-circle
          .modal-body.p-0
            .modern-view-banner-wrap
              img.modern-view-banner.img-fluid(:src='fifaCampaignBannerImage' @click='openFifaCampaignBanner')
  #uuslot-promo.modal.modal-common.fade(tabindex='-1' role='dialog' aria-labelledby='uuslot-promo' aria-hidden='true')
    .modal-dialog.modal-dialog-centered(role='document')
      .modal-content
        .btn-close(data-bs-dismiss='modal' aria-label='Close')
          i.fas.fa-times-circle
        .modal-body.p-0
          iframe.promo-frame(
            v-if='showUuslotPromoFrame'
            :src='uuslotPromoUrl'
            title='9th Anniversary'
          )
  searchModal
  toolBar
  //- minigamesModal
  betSingleModal
  betSingleStatus
  betParlayModal
  betParlayStatus
  betSingleMMOModal
  betSingleMMOStatus
  betParlayMMOModal
  betParlayMMOStatus
  //- searchModal
  timeMachineModal
  nicknameModal
  passwordModal
  languageModal
  allSportsModal
  oddsTypeModal
  defaultEventSortingModal
  sidebar
  router-view
  footerNav
  topButton
  //- floating
</template>

<script>
import config from "@/config";
import eventengine from "@/components/eventEngine";
import floating from "@/components/mobile/floating";

import betSingleModal from "@/components/mobile/bets/new2/new/betSingleModal";
import betSingleStatus from "@/components/mobile/bets/new2/new/betSingleStatus";
import betParlayModal from "@/components/mobile/bets/new2/new/betParlayModal";
import betParlayStatus from "@/components/mobile/bets/new2/new/betParlayStatus";

import betSingleMMOModal from "@/components/mobile/bets/new2/mmo/betSingleModal";
import betSingleMMOStatus from "@/components/mobile/bets/new2/mmo/betSingleStatus";
import betParlayMMOModal from "@/components/mobile/bets/new2/mmo/betParlayModal";
import betParlayMMOStatus from "@/components/mobile/bets/new2/mmo/betParlayStatus";

import minigamesModal from "@/components/mobile/minigamesModal";
import timeMachineModal from "@/components/mobile/timeMachine/timeMachineModal";

// import betResultModal from "@/components/mobile/bets/betResultModal";
import searchModal from "@/components/mobile/searchModal";
import leagueModal from "@/components/mobile/leagueModal";
import nicknameModal from "@/components/mobile/account/nicknameModal";
import passwordModal from "@/components/mobile/account/passwordModal";
import languageModal from "@/components/mobile/account/languageModal";
import oddsTypeModal from "@/components/mobile/account/oddsTypeModal";
import defaultEventSortingModal from "@/components/mobile/account/defaultEventSortingModal";
import allSportsModal from "@/components/mobile/account/allSportsModal";
import topButton from "@/components/mobile/topButton";

import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import sidebar from "@/components/mobile/sidebar";
import { NEW_UI_LOBBY_MODAL_SEEN_KEY, UUSLOT_PROMO_MODAL_SEEN_KEY } from "@/sessionUiKeys";

export default {
  components: {
    eventengine,
    minigamesModal,
    floating,
    betSingleModal,
    betSingleStatus,
    betParlayModal,
    betParlayStatus,
    // betResultModal,
    betSingleMMOModal,
    betSingleMMOStatus,
    betParlayMMOModal,
    betParlayMMOStatus,
    timeMachineModal,
    searchModal,
    leagueModal,
    nicknameModal,
    passwordModal,
    languageModal,
    oddsTypeModal,
    defaultEventSortingModal,
    allSportsModal,
    topButton,
    sidebar,
    toolBar,
    footerNav
  },
  data() {
    return {
      showUuslotPromoFrame: false,
      uuslotPromoUrl: "https://l22campaign.com/campaign/9th-anniversary/en"
    };
  },
  computed: {
    wcMode() {
      return config.wcMode;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    fifaCampaignBannerImage() {
      const suffix = this.$store.getters.language === "cn" ? "cn" : "en";
      return `images/FIFA June26 Campaign Banner_480x270_${suffix}.jpg`;
    }
  },
  watch: {
    $route() {
      this.maybeShowNewUiLobbyModal();
    }
  },
  mounted() {
    this._onNewUiModalShown = () => {
      try {
        sessionStorage.setItem(NEW_UI_LOBBY_MODAL_SEEN_KEY, "1");
      } catch (e) {}
    };
    this._onNewUiModalHidden = () => {
      this.maybeShowUuslotPromoModal();
    };
    this._onUuslotPromoModalShown = () => {
      try {
        sessionStorage.setItem(UUSLOT_PROMO_MODAL_SEEN_KEY, "1");
      } catch (e) {}
    };
    this._onUuslotPromoModalHidden = () => {
      this.showUuslotPromoFrame = false;
    };
    $("#new-ui").on("shown.bs.modal", this._onNewUiModalShown);
    $("#new-ui").on("hidden.bs.modal", this._onNewUiModalHidden);
    $("#uuslot-promo").on("shown.bs.modal", this._onUuslotPromoModalShown);
    $("#uuslot-promo").on("hidden.bs.modal", this._onUuslotPromoModalHidden);
    this.maybeShowNewUiLobbyModal();
  },
  beforeDestroy() {
    $("#new-ui").off("shown.bs.modal", this._onNewUiModalShown);
    $("#new-ui").off("hidden.bs.modal", this._onNewUiModalHidden);
    $("#uuslot-promo").off("shown.bs.modal", this._onUuslotPromoModalShown);
    $("#uuslot-promo").off("hidden.bs.modal", this._onUuslotPromoModalHidden);
  },
  methods: {
    maybeShowNewUiLobbyModal() {
      if (this.$route.name !== "lobby" || !this.$store.getters.isLoggedIn) return;
      // #new-ui is only rendered in wcMode. Without it, hidden.bs.modal never fires,
      // so the promo must open on its own.
      if (!this.wcMode) {
        this.maybeShowUuslotPromoModal();
        return;
      }
      try {
        if (sessionStorage.getItem(NEW_UI_LOBBY_MODAL_SEEN_KEY)) {
          this.maybeShowUuslotPromoModal();
          return;
        }
      } catch (e) {
        return;
      }
      this.$nextTick(() => {
        const $modal = $("#new-ui");
        if (!$modal.length) {
          this.maybeShowUuslotPromoModal();
          return;
        }
        $modal.modal("show");
      });
    },
    maybeShowUuslotPromoModal() {
      if (this.$route.name !== "lobby" || !this.$store.getters.isLoggedIn) return;
      try {
        if (sessionStorage.getItem(UUSLOT_PROMO_MODAL_SEEN_KEY)) return;
      } catch (e) {
        return;
      }
      this.showUuslotPromoFrame = true;
      this.$nextTick(() => {
        $("#uuslot-promo").modal("show");
      });
    },
    openFifaCampaignBanner() {
      window.open("https://q.me-qr.com/iaylbdo3", "_blank");
    }
  }
};
</script>

<style scoped>
#uuslot-promo .promo-frame {
  display: block;
  width: 100%;
  height: 75vh;
  border: 0;
  background: #fff;
}
</style>
